export enum PointType {
    DISPATCHABLE_POINT = <any> "DISPATCHABLE_POINT",
    MILEPOST = <any> "MILEPOST",
    SIGNAL = <any> "SIGNAL",
    SWITCH = <any> "SWITCH"
}